import React, { useEffect } from 'react';
import {
  Modal,
  Icon,
  FormSelect,
  Message,
  FormField,
  Input,
  Button,
  Form,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Chance from 'chance';
import md5 from 'md5';
import AttachmentAddPopup from '../AttachmentAddPopup/AttachmentAddPopup';
import EditPopup from '../EditPopup/EditPopup';
import api from '../../api';
import styles from './SettlementManageModal.module.scss';
import { useForm } from '../../hooks';
import { uploadFile } from '../../utils/cos';

const promotionMapMessage = new Map([
  ['settlement exceeds available', '结算超出可用'],
  ['settlement amount required', '请填写结算金额后在提交'],
  ['id', '请选择用户后再提交'],
  ['amount', '请填写结算金额后在提交'],
]);
const promotionMapColor = new Map([
  ['settlement exceeds available', 'red'],
  ['settlement amount required', 'red'],
  ['id', 'red'],
  ['amount', 'red'],
]);
function SettlementModal({ onClose, onInit }) {
  const [message, setMessage] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [pendingSettlementAmount, setPendingSettlementAmount] = React.useState(0);
  const [picture, setPicture] = React.useState(null);
  const [data, handleFieldChange, setData] = useForm({
    id: '',
    amount: '',
    dirname: '',
    filename: '',
    name: '',
  });
  const onAttachmentCreate = async (event) => {
    const dirname = md5(`${new Chance().string({ length: 6 })}`);
    const res = await uploadFile(`/attachments/${dirname}`, event.file);
    setPicture(res.Location);
    setData((prv) => ({ ...prv, dirname, filename: event.file.name, name: event.file.name }));
  };
  const onMessageDismiss = () => {
    setMessage(null);
  };
  const onUpdate = (event) => {
    setData((prv) => ({ ...prv, name: event.name }));
  };
  const handleSubmit = () => {
    if (!data.id) {
      setMessage('id');
      return;
    }
    if (Number(data.amount) > Number(pendingSettlementAmount)) {
      setMessage('settlement exceeds available');
      return;
    }
    api
      .createSettlement({
        ...data,
        amount: data.amount ? data.amount : pendingSettlementAmount,
      })
      .then(() => {
        onInit();
        onClose();
      })
      .catch((err) => {
        setMessage(err.message);
      });
  };
  useEffect(() => {
    if (data.id) {
      api.getPromoterAmount(data.id).then((res) => {
        setPendingSettlementAmount(res.item.pendingSettlementAmount);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.id]);
  useEffect(() => {
    api.getPromoterLists().then((res) => {
      setOptions(res.item);
    });
  }, []);
  return (
    <Modal
      open
      closeIcon
      size="small"
      centered={false}
      onClose={onClose}
      className={styles.content}
    >
      <Modal.Header>新增结算</Modal.Header>
      <Modal.Content scrolling>
        {message && (
          <Message color={promotionMapColor.get(message)} visible onDismiss={onMessageDismiss}>
            {promotionMapMessage.get(message)}
          </Message>
        )}
        <Form className={styles.form}>
          <FormField className={styles.field}>
            <p>
              姓名
              <span className={styles.span}>*</span>
            </p>
            <FormSelect
              name="id"
              fluid
              options={options}
              onChange={handleFieldChange}
              placeholder="请选择推广员"
            />
          </FormField>
          <FormField className={styles.field}>
            <p>
              结算金额（¥）
              <span className={styles.span}>*</span>
            </p>
            <Input
              name="amount"
              type="number"
              placeholder={`最多可结算金额：${pendingSettlementAmount}`}
              value={data.amount}
              onChange={handleFieldChange}
            />
          </FormField>
          {picture ? (
            <>
              <EditPopup
                defaultData={{
                  name: data.name,
                }}
                onUpdate={onUpdate}
                onDelete={() => {
                  setPicture(null);
                  setData((prv) => ({ ...prv, dirname: '', filename: '', name: '' }));
                }}
              >
                <Button>修改</Button>
              </EditPopup>
              <div className={styles.box}>
                <img src={`https://${picture}`} alt="附件" className={styles.attachment} />
                <span>{data.name}</span>
              </div>
            </>
          ) : (
            <AttachmentAddPopup onCreate={onAttachmentCreate}>
              <Button fluid className={styles.actionButton}>
                <Icon name="attach" className={styles.actionIcon} />
                添加附件
              </Button>
            </AttachmentAddPopup>
          )}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={handleSubmit}>
          新增
        </Button>
        <Button onClick={onClose}>取消</Button>
      </Modal.Actions>
    </Modal>
  );
}

SettlementModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onInit: PropTypes.func.isRequired,
};

export default SettlementModal;
